import { Button } from '@distribusion/owl-frontend-ui'
import React from 'react'

import Amenity from '@components/JourneyCard/Footer/Amenity'
import Money from '@components/Money'
import connectionUtils from '@lib/connection'
import fareUtils from '@lib/fare'
import { useTranslation } from '@lib/i18n'

import '@components/CompactTripCard/FareClassCard/styles.scss'

interface FareClassCardProps {
  connection: Connection
  fare: Fare
  onSelect?: (fareClass: string) => void
}

const FareClassCard = ({ connection, fare, onSelect }: FareClassCardProps) => {
  const { t } = useTranslation()
  const price = connectionUtils.getPrice(connection, fare)
  const displayedFareFeatures = fareUtils.getActualFareFeaturesAmenitiesByFareClass(connection, fare.fareClass.code)

  const onSelectHandler = (fareClass: string) => {
    onSelect?.(fareClass)
  }

  return (
    <div className="fare-class-card">
      <div className="fare-class-name">{fare.fareClass.name}</div>
      <div className="fare-class-price">
        <Money {...price} signed={false} />
      </div>
      <div className="fare-class-amenity-container">
        {displayedFareFeatures.map(item => {
          return (
            <div className="fare-class-amenity" key={item.id}>
              <Amenity key={item.id} fareFeature={item} />
              <span className="amenity-label">{item.name}</span>
            </div>
          )
        })}
      </div>
      <div className="fare-class-btn-container">
        <Button
          variant="text"
          fullWidth={false}
          className="fare-class-btn"
          onClick={() => onSelectHandler(fare.fareClass.code)}
        >
          {t('compactTripCard.buttonSelect')}
        </Button>
      </div>
    </div>
  )
}

export default FareClassCard
